import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { transportApi } from '@/services/transportApi';

export const CANCELLABLE = ['ASSIGNED', 'READY_TO_LOAD', 'IN_TRANSIT', 'RETURNING', 'UNLOADING'];

/** Manager: cancel a stuck / wrong trip (reason required). Frees vehicle + driver. */
export const CancelTripDialog = ({ trip, onClose, onDone }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { setReason(''); }, [trip]);

  const submit = async () => {
    if (reason.trim().length < 3) { toast.error('Enter a reason for cancelling'); return; }
    setBusy(true);
    try {
      const res = await transportApi.cancelTrip(trip.id, reason.trim());
      toast.success(res.request_released ? 'Trip cancelled — the request is back to Pending' : 'Trip cancelled — vehicle and driver are free');
      onDone?.(); onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Cancel failed'); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!trip} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="cancel-trip-dialog">
        <DialogHeader>
          <DialogTitle>Cancel trip?</DialogTitle>
          <DialogDescription data-testid="cancel-trip-summary">
            {trip?.route_summary || `${trip?.pickup || '—'} → ${trip?.drop || '—'}`} · {trip?.vehicle_label} · {trip?.driver_name || '—'} · {trip?.status}
          </DialogDescription>
        </DialogHeader>
        <p className="text-xs text-gray-600">The vehicle and driver become free and the driver gets a message. If this is the request's current trip, the request goes back to <b>Pending</b>.</p>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (required) — e.g. duplicate assignment" rows={3} data-testid="cancel-trip-reason" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="cancel-trip-back">Keep trip</Button>
          <Button onClick={submit} disabled={busy || reason.trim().length < 3} className="bg-red-600 hover:bg-red-700" data-testid="cancel-trip-confirm">{busy ? 'Cancelling…' : 'Cancel trip'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CancelTripDialog;
